import React, { useId } from 'react';

function Checkbox({
  checked,
  className = '',
  disabled = false,
  helperText,
  id,
  label,
  name,
  onChange,
  value,
  ...rest
}) {
  const generatedId = useId();
  const fieldId = id || name || `custom-checkbox-${generatedId}`;

  return (
    <label
      className={[
        'custom-checkbox',
        checked ? 'custom-checkbox--checked' : '',
        disabled ? 'custom-checkbox--disabled' : '',
        className,
      ].filter(Boolean).join(' ')}
      htmlFor={fieldId}
    >
      <input
        id={fieldId}
        name={name}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        value={value}
        onChange={onChange}
        className="custom-checkbox__input"
        {...rest}
      />
      <span className="custom-checkbox__box" aria-hidden="true" />
      {(label || helperText) && (
        <span className="custom-checkbox__text">
          {label && <span>{label}</span>}
          {helperText && <small>{helperText}</small>}
        </span>
      )}
    </label>
  );
}

export default Checkbox;
